<template>
	<div class="mb-10 w-full space-y-1">
		<h2 class="mb-0 text-left lg:m-auto lg:text-center">
			Frequently asked questions
		</h2>
		<p class="text-left text-3xl lg:m-auto lg:text-center">
			on an electric car subscription
		</p>
	</div>

	<div class="mt-8 xl:px-44">
		<AccordionFaq>
			<AccordionFaqGroup :double-borders="true">
				<AccordionFaqItem :is-checked="true">
					<template #title>
						Can you plug an electric vehicle into a regular outlet?
					</template>
					<template #content>
						<div class="mt-4 space-y-4 text-lg text-gray-575">
							<div>
								Yes, all electric vehicle subscriptions come
								with a slow (trickle) charger that can be
								connected to a general-purpose outlet, or
								household power point.
							</div>
							<div>
								Charging your car with these chargers can be
								slow but they can safely charge the battery all
								day, or night without damaging it.
							</div>
							<div>
								Most feature automatic cycles that turn off the
								charger when the battery is at its optimum
								capacity.
							</div>
						</div>
					</template>
				</AccordionFaqItem>
			</AccordionFaqGroup>

			<AccordionFaqGroup>
				<AccordionFaqItem>
					<template #title>
						Where can you charge my electric vehicle if you’re not
						home?
					</template>
					<template #content>
						<div class="mt-4 space-y-4 text-lg text-gray-575">
							<div>
								While home charging may be cheaper and easier to
								use day-to-day, it won't always serve you on
								longer journeys.
							</div>
							<div>
								Like a phone, your car will need to be charged
								after a certain amount of use. So for long
								trips, you'll need to turn to the growing number
								of public charging stations to recharge.
							</div>
							<div>
								The Electric Vehicle Council provides a map of
								charging stations across Australia. While
								recharging is not the same as refuelling, it is
								important to note however, that some charging
								stations may require a fee in the same way that
								you pay for petrol.
							</div>
						</div>
					</template>
				</AccordionFaqItem>
			</AccordionFaqGroup>

			<AccordionFaqGroup>
				<AccordionFaqItem>
					<template #title>
						What happens if I run out of battery on the road?
					</template>
					<template #content>
						<div class="mt-4 space-y-4 text-lg text-gray-575">
							<div>
								If you subscribe to an electric vehicle and run
								out of charge when you’re not home, you will
								have access to 24/7 Roadside Assistance
								Australia-wide.
							</div>
							<div>
								As a carbar subscriber, you will have unlimited
								callouts for flat batteries (charges), key
								lock-outs, flat tyre changes, breakdowns, towing
								and more.
							</div>
						</div>
					</template>
				</AccordionFaqItem>
			</AccordionFaqGroup>

			<AccordionFaqGroup>
				<AccordionFaqItem>
					<template #title>
						Can you help me install a home charger?
					</template>
					<template #content>
						<div class="mt-4 space-y-4 text-lg text-gray-575">
							<div>
								An electric car subscription excludes tolls,
								infringements and home chargers.
							</div>
							<div>
								Costs to buy and install home chargers vary
								depending on where you live, which charger you
								purchase, and whether it is hardwired to your
								home or portable.
							</div>
							<div>
								JET Charge is our preferred partner, offering
								globally recognised turnkey electric car
								charging infrastructure.
							</div>
						</div>
					</template>
				</AccordionFaqItem>
			</AccordionFaqGroup>
		</AccordionFaq>
	</div>
</template>

<script setup>
import AccordionFaq from '@/components/faqs/AccordionFaq.vue'
import AccordionFaqGroup from '@/components/faqs/AccordionFaqGroup.vue'
import AccordionFaqItem from '@/components/faqs/AccordionFaqItem.vue'
</script>
